import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { SecureKeys } from '@heviton/bridge-protocol';
import { isNative, bridgeSecureStorage } from '@/shared/bridge';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  setTokens: (tokens: { access: string; refresh: string }) => void;
  clear: () => void;
}

const storage = createJSONStorage(() => (isNative() ? bridgeSecureStorage : localStorage));

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      setTokens: ({ access, refresh }) => set({ accessToken: access, refreshToken: refresh }),
      clear: () => {
        // 메모리 초기화 후 persist storage 키 자체 제거.
        // 단순 set 만 하면 `{accessToken:null, refreshToken:null}` JSON 이 storage 에 남아
        // native keychain dump 시 빈 record 가 보임. clearStorage 로 키째 삭제해 위생 유지.
        set({ accessToken: null, refreshToken: null });
        void useAuthStore.persist.clearStorage();
      },
    }),
    {
      // SecureKeys.auth = 'heviton.auth' — native fresh-install cleanup 과 SSOT 정합.
      name: SecureKeys.auth,
      storage,
      partialize: (s) => ({ accessToken: s.accessToken, refreshToken: s.refreshToken }),
    },
  ),
);
